module.exports = __webpack_public_path__ + "img/school-logo-hover.236d74cd.png";